import React, { Fragment, useState } from "react";
import moment from "moment-hijri";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Convertir une Date du Hégirien au Grégorien";
const DESCRIPTION =
  "Convertir une Date du Hégirien au Grégorien pour calculer des dates, durees ou ages avec precision. Outil pratique pour vos demarches administratives, votre organisation personnelle et vos besoins du quotidien.";
const KEYWORDS =
  "convertir une date du hégirien au grégorien, calculatrice convertir une date du hégirien au grégorien, calcul en ligne, age, date, temps, calendrier, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/hijri_to_gregorian";

const HIJRI_MONTHS = [
  "Muharram",
  "Safar",
  "Rabi' al-awwal",
  "Rabi' al-Thani",
  "Jumada al-awwal",
  "Jumada al-Thani",
  "Rajab",
  "Sha'ban",
  "Ramadan",
  "Shawwal",
  "Dhu al-Qi'dah",
  "Dhu al-Hijjah",
];

function ConversionToGregorian() {
  const [hijriYear, setHijriYear] = useState("");
  const [hijriMonth, setHijriMonth] = useState("1");
  const [hijriDay, setHijriDay] = useState("1");
  const [gregorianDate, setGregorianDate] = useState("");
  const [showError, setShowError] = useState(false);

  const convertToGregorian = () => {
    if (!hijriYear) {
      setShowError(true);
      return;
    }

    const hijriStr = `${hijriYear}-${hijriMonth}-${hijriDay}`;
    const isValidDate = moment(hijriStr, "iYYYY-iM-iD", true).isValid();

    if (isValidDate && parseInt(hijriYear) > 1357) {
      const convertedDate = moment(hijriStr, "iYYYY-iM-iD").format("YYYY-M-D");
      setGregorianDate(convertedDate);
      setShowError(false);
    } else {
      setGregorianDate("");
      setShowError(true);
    }
  };

  return (
    <div style={{ direction: "ltr" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light ">
            <div className="row ">
              <div className="p-3">
                <p>
                  Cette calculatrice en ligne offre un moyen facile de convertir des dates du calendrier hégirien au grégorien. Il suffit au utilisateur de choisir le sens de la conversion et d'entrer la date hégirien qu'il souhaite convertir. Ensuite, la calculatrice effectue l'opération automatiquement et fournit la date convertie en calendrier grégorien. Le résultat s'affiche dans un format numérique et fourni le jour, le mois et l'année de manière détaillée. Cette calculatrice permet aux utilisateurs d'obtenir rapidement et avec précision les dates converties entre les calendriers hégirien et grégorien, ce qui facilite l'organisation des heures et des événements dans la vie quotidienne.
                </p>
                <br />
                <p>
                  Vous pouvez, grâce à cette calculatrice, entrer la date en format hégirien, et elle effectuera la conversion de la date saisie à son équivalent en date grégorien selon le calendrier Um al-Qura.
                </p>
              </div>
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="row ">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Convertisseur de Date du Hégirien au Grégorien
                </div>
                <div>
                  <label
                    style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "10px" }}
                  >
                    Entrez la Date Hégirien
                  </label>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <label  style={{ fontSize: "14px" }}>Jour</label>
                    <select
                      className="form-control"
                      value={hijriDay}
                      onChange={(e) => setHijriDay(e.target.value)}
                      style={{ fontSize: "16px", padding: "10px" }}
                    >
                      {Array.from({ length: 30 }, (_, i) => i + 1).map(day => (
                        <option key={day} value={day}>{day}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label  style={{ fontSize: "14px" }}>Mois</label>
                    <select
                      className="form-control"
                      value={hijriMonth}
                      onChange={(e) => setHijriMonth(e.target.value)}
                      style={{ fontSize: "16px", padding: "10px" }}
                    >
                      {HIJRI_MONTHS.map((month, index) => (
                        <option key={index} value={index + 1}>
                          {index + 1} - {month}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label  style={{ fontSize: "14px" }}>Année</label>
                    <select
                      className="form-control"
                      value={hijriYear}
                      onChange={(e) => setHijriYear(e.target.value)}
                      style={{ fontSize: "16px", padding: "10px" }}
                    >
                      <option value="">Année</option>
                      {Array.from(
                        { length: 600 },
                        (_, i) => 1500 - i
                      ).map(year => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="text-center mt-3">
                  <button className="btn btn-success btn-lg px-5" onClick={convertToGregorian}>
                    Convertir
                  </button>
                </div>

                {showError && (
                  <div className="alert alert-danger mt-3">
                    Veuillez entrer une date hégirien valide
                  </div>
                )}

                {gregorianDate && (
                  <div className="alert alert-success mt-3">
                    <strong>Date Grégorien Convertie:</strong>
                    <div style={{ fontSize: "24px", color: "#28a745", marginTop: "10px" }}>
                      {gregorianDate}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <br />
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
          <RelatedLinks />
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conversion de l’hégirien vers le grégorien</h3></div>
              <div className="info-section-body">
                <p>Pour convertir une date hégirienne en date grégorienne, on utilise une formule mathématique basée sur la différence de cycles entre les deux calendriers. Le calendrier hégirien a commencé le 16 juillet 622 après J.-C. (calendrier grégorien), correspondant à la migration du Prophète Mohammed de La Mecque à Médine. Chaque mois hégirien dure 29 ou 30 jours selon les phases lunaires.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Les mois du calendrier hégirien</h3></div>
              <div className="info-section-body">
                <p>Le calendrier islamique compte 12 mois : Mouharram, Safar, Rabiʾ al-Awwal, Rabiʾ al-Ḥānī, Joumada al-Oulâ, Joumada ath-Thânia, Rajab, Chaʼbān, Ramadan, Chawwāl, Dhou al-Qiʼda et Dhou al-Ḥijja. Ramadan est le mois du jeûne, et Dhou al-Ḥijja est le mois du pèlerinage (Hajj).</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConversionToGregorian;
